import { render } from "./HasRole.vue?vue&type=template&id=4de92e91&ts=true"
import script from "./HasRole.vue?vue&type=script&lang=ts"
export * from "./HasRole.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__